import type { WorkspaceMemberDTO } from '@trevize/api/types'

type ZeroUser = {
  id: string
  email?: string | null
  image?: string | null
  name?: string | null
  createdAt?: number | null
  updatedAt?: number | null
}

export type ZeroWorkspaceMemberRow = {
  userId: string
  role: string
  status?: 'active' | 'suspended' | 'invited' | null
  user?: ZeroUser | null
}

export type ZeroWorkspaceInvitationRow = {
  id: string
  email: string
  role: string
  user?: ZeroUser | null
}

export type WorkspaceMemberListItem = WorkspaceMemberDTO & {
  status?: 'active' | 'suspended' | 'invited'
}

export function workspaceMembersFromZero(
  members: ReadonlyArray<ZeroWorkspaceMemberRow>,
  invitations: ReadonlyArray<ZeroWorkspaceInvitationRow>,
): WorkspaceMemberListItem[] {
  const invitedStatus: WorkspaceMemberListItem['status'] = 'invited'

  return [
    ...members.map((member) => ({
      id: member.user?.id ?? member.userId,
      email: member.user?.email ?? null,
      image: member.user?.image ?? null,
      name: member.user?.name ?? null,
      createdAt: new Date(member.user?.createdAt ?? 0),
      updatedAt: new Date(member.user?.updatedAt ?? 0),
      status: member.status ?? 'active',
      roles: [member.role],
    })),
    ...invitations.map((invitation) => ({
      id: invitation.user?.id ?? invitation.id,
      email: invitation.user?.email ?? invitation.email,
      image: invitation.user?.image ?? null,
      name: invitation.user?.name ?? null,
      createdAt: new Date(invitation.user?.createdAt ?? 0),
      updatedAt: new Date(invitation.user?.updatedAt ?? 0),
      status: invitedStatus,
      roles: [invitation.role],
    })),
  ]
}
